import {useSelector} from 'react-redux';

export function useLocale() {
    return useSelector(
        (state: {languageProvider: {locale: string}}) => state.languageProvider.locale
    );
}
